import React from "react";
import { motion } from "framer-motion";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { EventAvailableIconWrapper } from "./styles";

export interface KLEventAvailableIconProps {
  /**
   * Size of the icon
   */
  size?: "small" | "medium" | "large";
  /**
   * Enable tap feedback animation (mobile-first)
   */
  animated?: boolean;
  /**
   * Add glow effect (recommended for large success icons)
   */
  withGlow?: boolean;
  /**
   * Use custom gradient styling
   */
  customStyle?: boolean;
}

const KLEventAvailableIcon: React.FC<KLEventAvailableIconProps> = ({
  size = "medium",
  animated = false,
  withGlow = true,
  customStyle = true,
}) => {
  const Component = animated ? motion.div : "div";

  return (
    <EventAvailableIconWrapper
      as={Component}
      $size={size}
      $withGlow={withGlow && customStyle && size !== "small"}
      $customStyle={customStyle}
      role="img"
      aria-label="אירוע אושר בהצלחה"
      {...(animated
        ? {
            whileTap: { scale: 0.95 },
            transition: { type: "spring", stiffness: 300, damping: 20 },
          }
        : {})}
    >
      <EventAvailableIcon />
    </EventAvailableIconWrapper>
  );
};

export default KLEventAvailableIcon;
